import type { DataItemId } from '@pn/core/domain/data';
import type { MapFeature } from '@pn/core/domain/map';
import { decomposeLayerId, isDataLayerId } from '@pn/core/domain/workspace';
import { assert } from '@pn/core/utils/assert';
import { isNil } from 'lodash-es';

export const mapboxMapFeatureMapper = {
  toDomainMapFeature: (
    mapboxGeoJSONFeature: mapboxgl.MapboxGeoJSONFeature
  ): MapFeature => {
    return {
      layerId: mapboxGeoJSONFeature.layer.id,
      internalId: getMapboxFeatureId(mapboxGeoJSONFeature),
      geometry: mapboxGeoJSONFeature.geometry,
      ...decomposeLayerId(mapboxGeoJSONFeature.layer.id),
    };
  },
};

export function isMapboxDataFeature(
  feature: mapboxgl.MapboxGeoJSONFeature
): boolean {
  return (
    isDataLayerId(feature.layer.id) &&
    (!isNil(feature.id) || !isNil(feature.properties?.internal_id))
  );
}

export function getMapboxFeatureId(
  mapboxGeoJSONFeature: mapboxgl.MapboxGeoJSONFeature
): DataItemId {
  const featureId =
    mapboxGeoJSONFeature.properties?.internal_id ?? mapboxGeoJSONFeature.id;
  assert(!isNil(featureId), 'MapboxGeoJSONFeature is missing ID');

  return featureId;
}
